/** Input feedback only; the backend validates the recipient before reserving a send. */
export function isWithdrawalRecipient(address: string, ownAddresses: readonly string[]): boolean {
  return /^[1-9A-HJ-NP-Za-km-z]{32,44}$/u.test(address) && !ownAddresses.includes(address);
}
